import React, { createContext, ReactNode, useContext, useState } from "react";
import { User } from "firebase/auth";

const AuthContext = createContext<{
  authUser: User | null;
  setAuthUser: React.Dispatch<React.SetStateAction<User | null>>;
}>({
  authUser: null,
  setAuthUser: () => {},
});

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const [authUser, setAuthUser] = useState<User | null>(null);

  return (
    <AuthContext.Provider value={{ authUser, setAuthUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
